import type { CurrencyCode } from '@shopify/hydrogen-react/storefront-api-types'

export const DEFAULT_CURRENCY = 'AUD' as CurrencyCode
